module.exports = __webpack_public_path__ + "static/media/no-picture.11af6f0e.svg";